/* eslint-disable */
import * as types from 'constants/espectacularesActionTypes';
import * as services from 'services/espectaculares.service';
import { MONITOREOS_ESPECTACULARES, ACTA_INICIO, ACTA_CIERRE } from 'constants/tipoMonitoreos';
import {
  actaInicioDTO,
  actaCierreDTO,
  monitoreoEspectacularesDTO
} from 'adapters/listadoMonitoreo';
import { ALERT_ERROR_TYPE } from 'constants/alertTypes';
import { showAlert } from 'actions/alert.actions';
import { message } from 'antd';
import { ERROR_SAVE } from 'constants/MensajesGenerales';

import { generarPDFMonitoreos } from 'services/monitoreos.service';

export const getMonitoreoEspectacularesViaPublica = (page, pageSize) => async (dispatch) => {
  dispatch({ type: types.GET_MONITOREOS_ESPECTACULARES_LOADING });
  const params = {
    cantidad: pageSize,
    pagina: page,
    tipoMonitoreo: MONITOREOS_ESPECTACULARES
  };
  try {
    const { data } = await services.fetchMonitoreos(params);
    const rows = data?.monitoreos?.espectaculares || [];
    const payload = await rows.map(monitoreoEspectacularesDTO);
    dispatch({ type: types.GET_MONITOREOS_ESPECTACULARES_SUCCESS, payload });
    // MNI - Se cambia la variable de retorno de total a totalActas ya que es la que espera el componente de TablaMonitoreos
    return { success: true, totalActas: data.monitoreos.totalMonEspectaculares };
  } catch (error) {
    dispatch({ type: types.GET_MONITOREOS_ESPECTACULARES_FAILURE, error });
    return { success: false };
  }
};

export const getMonitoreosEspectacularesActaInicio =
  (page, pageSize, folioActaInicio) => async (dispatch) => {
    dispatch({ type: types.GET_ESPECTACULARES_ACTA_INICIO_LOADING });
    const params = {
      cantidad: pageSize,
      pagina: page,
      tipoMonitoreo: MONITOREOS_ESPECTACULARES,
      tipoActa: ACTA_INICIO
    };
    try {
      const { data } = await services.fetchMonitoreos(params);
      const filteredMonitoreos = data?.monitoreos?.espectaculares?.flatMap((espectacular) =>
        espectacular.actas
          .filter((acta) => acta.idTipoActa === ACTA_INICIO)
          .map((acta) => ({ ...espectacular, actas: [acta] }))
      );
      let monitoreosUnicos = [];
      if (filteredMonitoreos.length > 0) {
        const seen = new Set();
        monitoreosUnicos = filteredMonitoreos.filter((espectacular) => {
          const key = `${espectacular.idMonitoreo}-${espectacular.estado}-${espectacular.actas[0].idActa}`;
          if (seen.has(key)) {
            return false;
          }
          seen.add(key);
          return true;
        });
      }
      let rows = [];
      if (folioActaInicio) {
        rows = monitoreosUnicos.filter((actaInicio) => actaInicio.folio === folioActaInicio);
      } else {
        rows = monitoreosUnicos || [];
      }
      const payload = rows.map(actaInicioDTO);
      dispatch({ type: types.GET_ESPECTACULARES_ACTA_INICIO_SUCCESS, payload });
      return { success: true, totalActas: data.monitoreos.totalMonEspectaculares };
    } catch (error) {
      dispatch({ type: types.GET_ESPECTACULARES_ACTA_INICIO_FAILURE, error });
      return { success: false };
    }
  };

export const getMonitoreosEspectacularesActaCierre =
  (page, pageSize, folioActaCierre) => async (dispatch) => {
    dispatch({ type: types.GET_ESPECTACULARES_ACTA_CIERRE_LOADING });
    const params = {
      cantidad: pageSize,
      pagina: page,
      tipoMonitoreo: MONITOREOS_ESPECTACULARES,
      tipoActa: ACTA_CIERRE
    };
    try {
      const { data } = await services.fetchMonitoreos(params);
      const filteredMonitoreos = data?.monitoreos?.espectaculares?.flatMap((espectacular) =>
        espectacular.actas
          .filter((acta) => acta.idTipoActa === ACTA_CIERRE)
          .map((acta) => ({ ...espectacular, actas: [acta] }))
      );
      let monitoreosUnicos = [];
      if (filteredMonitoreos.length > 0) {
        const seen = new Set();
        monitoreosUnicos = filteredMonitoreos.filter((espectacular) => {
          const key = `${espectacular.idMonitoreo}-${espectacular.estado}-${espectacular.actas[0].idActa}`;
          if (seen.has(key)) {
            return false;
          }
          seen.add(key);
          return true;
        });
      }
      let rows = [];
      if (folioActaCierre) {
        rows = monitoreosUnicos.filter((actaCierre) => actaCierre.folio === folioActaCierre);
      } else {
        rows = monitoreosUnicos || [];
      }
      const payload = rows.map(actaCierreDTO);
      dispatch({ type: types.GET_ESPECTACULARES_ACTA_CIERRE_SUCCESS, payload });
      return { success: true, totalActas: data.monitoreos.totalMonEspectaculares };
    } catch (error) {
      dispatch({ type: types.GET_ESPECTACULARES_ACTA_CIERRE_FAILURE, error });
      return { success: false };
    }
  };

export const upsertEspectacularesActaInicio = (payload, pagina, pageSize) => async (dispatch) => 
{
  dispatch({ type: types.UPSERT_ESPECTACULARES_ACTA_INICIO_LOADING });
  try  
  {
    const { data: { monitoreos, hallazgos, formatos } } = await services.sincronizarActa(payload);

    if (
      monitoreos?.synced?.length === 0 ||
      hallazgos?.notSynced?.length > 0 ||
      formatos?.notSynced?.length > 0
    ) {
      const errorMessage = ERROR_SAVE;
      dispatch({
        type: types.UPSERT_ESPECTACULARES_ACTA_INICIO_FAILURE,
        error: { message: errorMessage }
      });
      dispatch(showAlert(errorMessage, ALERT_ERROR_TYPE));
      return { success: false };
    } else {
      // console.log('Guardó correctamente: ', payload);

      // Variable a enviar para generar PDF del monitoreo
      // payload.actasInicio.toUpdate[0]? payload.actasInicio.toUpdate[0].idMonitoreo  => Es para Edición
      // monitoreos.synced[0].id => Es para una nueva acta
      let monitoreoPDF = [{
          idMonitoreo     : payload.actasInicio.toUpdate[0]? payload.actasInicio.toUpdate[0].idMonitoreo : monitoreos.synced[0].id
        , idTipoMonitoreo : 1             // 1 MONITOREOS_ESPECTACULARES
        , tiposActa       : [{ "id": 1 }] // 1 Para Acta Inicio
      }];

      // Se genera PDF una vez que se han almacenado las Muestras
      let generoPDF = await generarPDFMonitoreos(monitoreoPDF);
      if(generoPDF)
      {
        console.log('Se generó correctamente el PDF');
      }else{
        console.log('Error al generar el PDF');
      }
    }
    dispatch({ type: types.UPSERT_ESPECTACULARES_ACTA_INICIO_SUCCESS, payload: monitoreos });
    dispatch(getMonitoreosEspectacularesActaInicio(pagina, pageSize));
    return { success: true, monitoreo: monitoreos };
  } catch (error) {
    return { success: false };
  }
};

export const upsertEspectacularesActaCierre = (payload, pagina, pageSize) => async (dispatch) => 
{
  dispatch({ type: types.UPSERT_ESPECTACULARES_ACTA_CIERRE_LOADING });
  try 
  {
    const {
      data: { monitoreos, hallazgos, formatos }
    } = await services.sincronizarActa(payload);
    if (
      monitoreos?.synced?.length === 0 ||
      hallazgos?.notSynced?.length > 0 ||
      formatos?.notSynced?.length > 0
    ) {
      const errorMessage = ERROR_SAVE;
      dispatch({
        type: types.UPSERT_ESPECTACULARES_ACTA_CIERRE_FAILURE,
        error: { message, errorMessage }
      });
      dispatch(showAlert(errorMessage, ALERT_ERROR_TYPE));
      return { success: false };
    }else{
      console.log('Guardó correctamente: ', payload);

      // Variable a enviar para generar PDF del monitoreo
      // payload.actasCierre.toUpdate[0].idMonitoreo Para edición
      // payload.actasCierre.toSave[0].idMonitoreo Para nuevos
      let monitoreoPDF = [{
          idMonitoreo     : payload.actasCierre.toUpdate[0]? payload.actasCierre.toUpdate[0].idMonitoreo : payload.actasCierre.toSave[0].idMonitoreo
        , idTipoMonitoreo : 1             // 1 MONITOREOS_ESPECTACULARES
        , tiposActa       : [{ "id": 3 }] // 3 Para Acta Cierre
      }];

      // Se genera PDF una vez que se han almacenado las Muestras
      let generoPDF = await generarPDFMonitoreos(monitoreoPDF);
      if(generoPDF)
      {
        console.log('Se generó correctamente el PDF');
      }else{
        console.log('Error al generar el PDF');
      }
    }
    dispatch({ type: types.UPSERT_ESPECTACULARES_ACTA_CIERRE_SUCCESS, payload: monitoreos });
    dispatch(getMonitoreosEspectacularesActaCierre(pagina, pageSize));
    return { success: true, monitoreo: monitoreos };
  } catch (error) {
    return { success: false };
  }
};

export const postEditMonEspectaculares = (data) => async () => {
  try {
    const response = await services.sincronizarActa(data);
    return { success: true, response };
  } catch (error) {
    return { success: false, response: error };
  }
};
